"use client";

import { useEffect, useRef } from "react";
import { useCookiePreferences } from "@/hooks/useCookiePreferences";
import { HUBSPOT_PORTAL_ID } from "@/data/hubspot-forms";

const HUBSPOT_SCRIPT_BASE = "https://js.hs-scripts.com";

function canLoadTracking(preferences: { marketing: boolean } | null) {
  if (!preferences) return false;
  return Boolean(preferences.marketing);
}

export default function HubSpotTrackingLoader() {
  const preferences = useCookiePreferences();
  const loadedRef = useRef(false);

  useEffect(() => {
    if (loadedRef.current) return;
    if (!canLoadTracking(preferences)) return;

    const src = `${HUBSPOT_SCRIPT_BASE}/${HUBSPOT_PORTAL_ID}.js`;
    if (document.querySelector(`script[src="${src}"]`)) {
      loadedRef.current = true;
      return;
    }

    const loadScript = () => {
      const script = document.createElement("script");
      script.id = "hs-script-loader";
      script.src = src;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
      loadedRef.current = true;
    };

    const idleCb = window.requestIdleCallback;
    if (typeof idleCb === "function") {
      const id = idleCb(loadScript, { timeout: 3000 });
      return () => window.cancelIdleCallback?.(id);
    }

    const timeoutId = window.setTimeout(loadScript, 1800);
    return () => window.clearTimeout(timeoutId);
  }, [preferences]);

  return null;
}
